/* ── Reusable section head ── */
function SectionHead({ eyebrow, title, sub, subtitle }) {
  return (
    <div className="text-center mb-12">
      <div className="text-xs font-bold uppercase tracking-widest text-violet-600 mb-2.5">{eyebrow}</div>
      <h2 className="font-extrabold text-gray-900 tracking-tight"
        style={{ fontSize: "clamp(26px,3.5vw,38px)", letterSpacing: "-0.02em", lineHeight: 1.15 }}>
        {title}
      </h2>
      {sub && (
        <p className="text-gray-500 text-sm leading-relaxed mt-3 max-w-lg mx-auto">{sub}</p>
      )}
      {subtitle && (
        <p className="text-gray-500 text-sm leading-relaxed mt-3 max-w-lg mx-auto">{subtitle}</p>
      )}
    </div>
  );
}

export default SectionHead;